import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { App } from "./app/App";
import { AccountProvider } from "./features/account/AccountContext";
import { ThemeController } from "./features/account/ThemeController";
import { CurrencyProvider } from "./features/currency/CurrencyContext";
import { CookieNotice } from "./features/legal/CookieNotice";
import "./styles.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const root = document.getElementById("root");
if (!root) {
  throw new Error("Root element is missing");
}

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AccountProvider>
        <ThemeController />
        <CurrencyProvider>
          <App />
          <CookieNotice />
        </CurrencyProvider>
      </AccountProvider>
    </QueryClientProvider>
  </StrictMode>,
);
